<template>
  <button
    :disabled="disabled || loader"
    :class="[computedClasses, selectedClass]"
    class="rounded-[8px] h-[42px] select-none"
  >
    <Flex center class="px-4">
      <slot>
        <IconSolid :icon="icon" :class="label ? 'mr-2' : ''" v-if="icon && !loader" />
        <IconSolid :icon="loaderIcon" v-if="loader" />
        {{ !loader ? label : '' }}
      </slot>
    </Flex>
  </button>
</template>

<script setup>
import { computed, defineProps } from 'vue'

const props = defineProps({
  label: String,
  color: String,
  icon: String,
  disabled: Boolean,
  loader: Boolean,
  block: Boolean,
  outlined: Boolean,
  primary: Boolean,
  success: Boolean,
  danger: Boolean,
  alert: Boolean,
  dark: Boolean,
  gray: Boolean,
  light: Boolean,
  selected: Boolean,
})

const loaderIcon = 'fa-solid fa-spinner fa-spin'

const computedClasses = computed(() => [
  { 'text-black': props.dark || props.gray },
  {
    'text-white': !props.dark && !props.outlined && !props.gray && !props.light,
  },
  { 'w-full': props.block },
  { 'inline-block': !props.block },
  { 'opacity-50 cursor-auto': props.disabled || props.loader },
  { 'bg-[#89ca45] border border-[#89ca45] hover:bg-[#7db53d] hover:border-[#7db53d] text-[#13161b]': props.primary && !props.outlined },
  {
    'border border-[#89ca45] hover:border-[#7db53d] text-[#6ea336] hover:bg-[#f6fbe8]': props.primary && props.outlined,
  },
  { 'bg-success-500 hover:bg-success-600': props.success && !props.outlined },
  {
    'border border-success-500 hover:border-success-600 text-success-500': props.success && props.outlined,
  },
  { 'bg-red-500 hover:bg-red-600': props.danger && !props.outlined },
  {
    'border border-red-500 hover:border-red-600 text-red-500': props.danger && props.outlined,
  },
  { 'bg-alert-500 hover:bg-alert-600': props.alert && !props.outlined },
  {
    'border border-alert-500 hover:border-alert-600 text-alert-500': props.alert && props.outlined,
  },
  { 'bg-white hover:bg-gray-100 border border-slate-300 text-[#575757]': props.light || props.gray },
])

const selectedClass = computed(() => {
  if (!props.selected || props.outlined) {
    return
  }
  if (props.primary) {
    return 'bg-[#6ea336] border-[#6ea336] hover:bg-[#6ea336] hover:border-[#6ea336] text-[#13161b]'
  }
  if (props.danger) {
    return 'bg-red-800 hover:bg-red-800'
  }
  if (props.alert) {
    return 'bg-alert-800 hover:bg-alert-800'
  }
  if (props.success) {
    return 'bg-success-800 hover:bg-success-800'
  }

  return ''
})
</script>
